import { EventTypes, EntityTypes, WorkflowReviewerType } from 'typings/enums';
import { IWorkflowEvent, IWorkflowApproveEvent } from 'typings/workflow';

export const getWorkflowEvent = (
    eventType: EventTypes,
    userId: string,
    userDisplayName: string,
    workflowRuleName: string,
    sourceId: string,
    workflowReviewerType: WorkflowReviewerType,
    comment: string): IWorkflowEvent => {

    return {
        eventType,
        entityType: EntityTypes.ManagerWorkflow,
        userId,
        data: {
            nextReviewer: {
                workflowRuleName,
                reviewerId: sourceId,
                workflowReviewerType
            },
            comment,
            date: new Date(),
            reviewerDisplayName: userDisplayName
        }
    } as IWorkflowEvent;
};

export const getWorkflowApproveEvent = (
    userId: string,
    comment: string): IWorkflowApproveEvent => {
    return {
        eventType: EventTypes.WorkflowApproveEvent,
        entityType: EntityTypes.ManagerWorkflow,
        userId,
        data: {
            approvedByUserId: userId,
            comment
        }
    } as IWorkflowApproveEvent;
};